<template>
  <div :class="$attrs.class">
    <list-skeleton
      v-if="feedbackReport.loading && !feedbackReport.hasNext"
      list-type="session"
    />
    <ul v-else class="dashboard-list">
      <li class="row header-labels sticky">
        <div class="col-6 subject">
          <div>Feedback</div>
        </div>
        <div class="col-6 data">
          <div>When</div>
          <div>Platform Rating</div>
          <div>Counselor Rating</div>
        </div>
      </li>
      <li v-if="feedbackReport.feedbacks.length === 0" class="empty">No Results</li>
      <li
        v-for="feedback in feedbackReport.feedbacks"
        :key="feedback.id"
        class="row"
        tabindex="0"
      >
        <div class="col-12 col-sm-6 subject">
          <span v-if="feedback.comment">
            {{ feedback.comment }}
          </span>
          <span v-else class="no-comment"> No comment </span>
        </div>
        <div class="col-12 col-sm-6 data">
          <transition name="update" mode="out-in">
            <div :key="`${feedback.id}_when`">
              <em class="sr-only-sm-up">When</em>
              {{ feedbackDate(feedback) }}
            </div>
          </transition>
          <transition name="update" mode="out-in">
            <div :key="`${feedback.id}_app`">
              <em class="sr-only-sm-up">Platform Rating</em>
              {{ feedback.appRating }}
            </div>
          </transition>
          <transition name="update" mode="out-in">
            <div :key="`${feedback.id}_counselor`">
              <em class="sr-only-sm-up">Counselor Rating</em>
              {{ feedback.counselorRating }}
            </div>
          </transition>
        </div>
      </li>
    </ul>
    <div v-if="displayLoadMoreButton" class="load-more">
      <button class="dash-button" @click="feedbackReport.fetch()">
        Load More Results
      </button>
    </div>
    <div v-if="feedbackReport.loading && feedbackReport.hasNext" class="list-progress-bar">
      <div class="value"></div>
      <span class="sr-only">loading</span>
    </div>

    <div
      v-if="feedbackReport.feedbacks.length > 0 && !feedbackReport.hasNext"
      class="end-of-list"
    >
      <font-awesome-icon :icon="['fas', 'check-circle']" class="icon alt" />
      <p>All Results Loaded</p>
    </div>
  </div>
</template>

<script>
import ListSkeleton from '../../../ListSkeleton.vue';
import moment from 'moment';

export default {
  name: 'FeedbackList',
  components:{
    ListSkeleton
  },

  inject:['feedbackReport'],

  computed: {
    displayLoadMoreButton() {
      return this.$globals.isMobile
        && this.feedbackReport.hasNext
        && !this.feedbackReport.loading;
    }
  },

  mounted() {
    this.feedbackReport.reset();
  },

  created() {
    window.addEventListener('scroll', this.handleScroll, { once:true });
  },

  destroyed() {
    window.removeEventListener('scroll', this.handleScroll, { once:true });
  },

  methods:{
    feedbackDate(feedback) {
      return moment(feedback.when).format('M/DD/yyyy')
    },

    async handleScroll() {
      if (!this || !this.feedbackReport) {
        return;
      }

      const atBottomOfWindow =
        document.documentElement.scrollTop + window.innerHeight >=
        document.documentElement.offsetHeight * 0.8;

      if (!this.$globals.isMobile && atBottomOfWindow && this.feedbackReport.hasNext) {
        await this.feedbackReport.fetch();
      }

      window.addEventListener('scroll', this.handleScroll, { once:true });
    },
  }
}
</script>

<style lang="scss" scoped>
.row {
  min-height: 83px;
  .no-comment {
    font-style: italic;
  }
}
</style>
